import { render, staticRenderFns } from "./lnk-upload-img.vue?vue&type=template&id=25e29442&scoped=true&"
import script from "./lnk-upload-img.vue?vue&type=script&lang=js&"
export * from "./lnk-upload-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e29442",
  null
  
)

export default component.exports